(ns common.email
  (:require [clojure.set :as set]
            [clojure.string :as string]
            [common.util :as cu]))

(def email-pattern #"(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])")

(defn valid-email? [email]
  ;; from https://stackoverflow.com/questions/33736473/how-to-validate-email-in-clojure
  (let [pattern #"[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-z0-9](?:[a-zA-Z0-9-]*[a-zA-z0-9])?"]
    (and (string? email)
         (re-matches pattern email))))

(defn optional-valid-email?
  [email]
  (or (cu/blank-value? email)
      (valid-email? email)))

(defn valid-email-pattern? [email]
  (and (string? email)                                      ;; one @ char and domain validation containing at least two parts separated with one . character - does not end in .
       (re-matches #"[^@]+\@[^@]+\.[^@.]+" email)))

(defn junk-filtering-email-pattern? [email]
  (and (string? email)                                      ;; one @ char and domain validation containing at least two parts separated with one . character - does not end in .
       (re-matches #"[a-z.]+\@[a-z]+\.[a-z.]*[a-z]+" email)))

(defn parse-email-addresses [email-str]
  (->> email-str
       (str)
       (string/lower-case)
       (cu/flip string/split #"\s")
       (map #(re-seq email-pattern %))
       (remove nil?)
       (flatten)
       (distinct)))

(def ignored-contact-domains
  #{"gmail.com"
    "yahoo.com"
    ""
    ;; TODO full list here
    })

(def ignored-email-local-partials
  #{"academic.administrator"
    "academy"
    "accountants"
    "account"
    "accounts"
    "action"
    "admin.office"
    "admin"
    "administration"
    "administrator"
    "adminoffice"
    "admissions"
    "advertising"
    "advice"
    "agency"
    "amministrazione"
    "analysis"
    "architect"
    "architects"
    "architecture"
    "assistant"
    "auction"
    "auctions"
    "bookings"
    "books"
    "business"
    "careers"
    "central"
    "chairman"
    "chambers"
    "clerk"
    "clerks"
    "club"
    "comercial"
    "commercial"
    "commerciale"
    "conference"
    "conferences"
    "connect"
    "construction"
    "consult"
    "contact.us"
    "contact"
    "contactus"
    "contracts"
    "corporate"
    "customer"
    "customer.services"
    "customercare"
    "customerservice"
    "customerservices"
    "delivery"
    "design"
    "details"
    "development"
    "director"
    "dont"
    "do-not"
    "donot"
    "editor"
    "editorial"
    "education"
    "email"
    "e-mail"
    "engineers"
    "enquire"
    "enquires"
    "enquiries"
    "enquiry"
    "enquries"
    "equipment"
    "estate"
    "euroinfo"
    "europe"
    "events"
    "export"
    "farmer"
    "feedback"
    "finance"
    "franchise"
    "freight"
    "frontdesk"
    "furniture"
    "gen.enquiries"
    "general.enquiries"
    "general"
    "generalenquiries"
    "genoffice"
    "graphics"
    "group"
    "head"
    "headmaster"
    "headoffice"
    "headteacher"
    "hello"
    "help"
    "helpdesk"
    "helpline"
    "hiredesk"
    "holidays"
    "hospitality"
    "hostmaster"
    "hotel"
    "ideas"
    "ignore"
    "image"
    "inbox"
    "info.uk"
    "infodesk"
    "informatica"
    "information"
    "informatique"
    "info"
    "infos"
    "info-uk"
    "inquires"
    "inquiries"
    "institute"
    "insurance"
    "insure"
    "invest"
    "jobs"
    "jpg"
    "jpeg"
    "junk"
    "kontakt"
    "Kontakti"
    "lawyers"
    "learning"
    "legal"
    "leisure"
    "lettings"
    "library"
    "mail"
    "mailbox"
    "mailroom"
    "main.office"
    "mainoffice"
    "management"
    "manager"
    "manchester"
    "marketing"
    "master"
    "media"
    "member"
    "membership"
    "news"
    "noemail"
    "noemailaddress"
    "nomail"
    "no-reply"
    "noreply"
    "occasion"
    "office.admin"
    "office"
    "officeadmin"
    "online"
    "operations"
    "orders"
    "outbox"
    "partners"
    "people"
    "personnel"
    "planning"
    "post"
    "postbox"
    "postmaster"
    "postroom"
    "president"
    "press"
    "principal"
    "print"
    "procurement"
    "producer"
    "production"
    "projects"
    "properties"
    "property"
    "purchasing"
    "quality"
    "reception"
    "recruit"
    "recruitment"
    "registrar"
    "rental"
    "repairs"
    "reply"
    "reservation"
    "reservations"
    "sale"
    "sales.uk"
    "salesinfo"
    "sales"
    "sales-uk"
    "school.office"
    "school"
    "schooladmin"
    "schoolinfo"
    "schoolmail"
    "schooloffice"
    "secretary"
    "security"
    "server"
    "service"
    "services"
    "shipping"
    "shop"
    "solicitors"
    "solutions"
    "spam"
    "sport"
    "staff"
    "studio"
    "success"
    "supervisor"
    "support"
    "surveying"
    "surveys"
    "systems"
    "team"
    "tech"
    "technical"
    "technik"
    "technique"
    "theoffice"
    "theteam"
    "tourism"
    "townclerk"
    "townhall"
    "trade"
    "trading"
    "traffic"
    "training"
    "travel"
    "treasurer"
    "trust"
    "ukinfo"
    "uk-info"
    "uksales"
    "used"
    "users"
    "webadmin"
    "webmail"
    "webmaster"
    "welcome"
    })

(def ignored-email-domain-partials
  #{"zapflow"})

(def ignored-email-local-parts
  (set/union ignored-email-domain-partials
             #{"all"
               "art"
               "eng"
               "hq"
               "hr"
               "it"
               "me"
               "pr"}))

(defn strict-junk-match? [local-part]
  (let [parts (string/split local-part #"\.")]
    (or (->> ["team" "startup" "sales" "marketing" "customer" "blog" "analyst"]
             (some #(string/includes? local-part %))
             (boolean))
        (and (> (count parts) 1)
             (= (first parts) (second parts))))))

(defn valid-contact-email? [email-address]
  (when-not (cu/blank-value? email-address)
    (let [[local-part domain-part] (string/split email-address #"@")]
      (and (not (ignored-email-local-parts local-part))
           (->> ignored-email-local-partials
                (not-any? (fn [lp]
                            (string/includes? local-part lp))))
           (->> ignored-email-domain-partials
                (not-any? (fn [dp]
                            (string/includes? domain-part dp))))))))

(defn eml-links->html [email-body]
  (->> email-body
       (re-seq #"([^<>\s]*)([ \t]*)<(http[^>]*)>")
       (map (fn [[full-match previous-word blanks link]]
              [full-match (cu/format "<a href=\"%s\">%s</a>%s"
                                     link
                                     (if (string/blank? previous-word)
                                       link
                                       previous-word)
                                     blanks)]))
       (reduce (fn [text [original replacement]]
                 (string/replace-first text original replacement))
               email-body)))

(defn http-texts->html-links [email-body]
  (->> email-body
       (re-seq #"([^\"<])(http[^\s]*)([^\">])")
       (keep (fn [[full-match previous-char link next-char]]
               [full-match (cu/format "%s<a href=\"%s\">%s</a>%s"
                                      previous-char link link next-char)]))
       (reduce (fn [text [original replacement]]
                 (string/replace-first text original replacement))
               email-body)))

(defn eml-body->html-links [email-body]
  (->> email-body
       (http-texts->html-links)
       (eml-links->html)))
